import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { QualityControlCompany, QualityControlCompanyCreateRequest } from "src/app/domain/models/QCCompany";

@Injectable({providedIn: 'root'})
export abstract class QualityControlCompanyGateway {
  abstract create(request: QualityControlCompanyCreateRequest): Observable<any>
  abstract getAllByOperationCountryId(operationCountryId: number): Observable<QualityControlCompany[]>
}
